<script setup lang="ts"></script>

<template>
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    data-slot="icon"
    aria-hidden="true"
  >
    <path
      d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    ></path>
  </svg>
</template>
